<template>
    <div class="agreement-confirm-main-box" v-if="flag">
        <div class="agreement-confirm-box">
            <div class="title">用户协议及隐私保护</div>
            <div class="content">
                <!-- 核心：删除HTML中的所有换行/空格，标签首尾紧连 -->
                <div class="content-text">
                    <span class="content-desc">我已同意并阅读</span>
                    <span v-for="(item, index) in agree" :key="index" class="agree-item tip"
                        @click="change(item)">{{ item.name }}</span><span class="content-desc">等内容</span></div>
            </div>
            <qa-router-button data-package-name="com.qiben.parking"
                data-click-event='{"eventName": "handleClickEvent", "eventParams": "anyString"}'
                data-page="pages/skipKey" :data-params='key1' v-if="env == 0" style="height: 82px;">
                <templates>
                    <div style="
            height: 55px;
			line-height: 55px;
			background: #3477fc;
			border-radius: 27px;
			margin-top: 26px;
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #FFFFFF;
			text-align: center;
			display: flex;
			justify-content: center;
			align-items: center;">
                        同意并继续
                    </div>
                </templates>
            </qa-router-button>
            <div class="submit-btn" @click="sure" v-else>同意并继续 </div>
            <div class="cancel-btn" @click="cflag">不同意</div>
        </div>

    </div>
</template>

<script>
export default {
    name: "Sure",
    data() {
        return {

        };
    },
    methods: {
        change(e) {
            console.log(e)
            if (e.url) {
                window.location.href = e.url
            } else {
                console.log(e.id)
                if (e.id == 1) {
                    this.$emit('ys', true)
                }
                else if (e.id == 3) {
                    this.$emit('rule', true)
                }
            }

        },
        sure() {
            this.$emit('sure', false)

        },
        cflag() {
            this.$emit('cflag', false)
        }
    },
    props: {
        flag: Boolean,
        agree: Array,
        env: String,
        key1: ''
    },
};
</script>


<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}

html,
body {
    width: 100%;
    height: 100%;
    font-family: "PingFang SC", "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei", sans-serif;
    -webkit-text-size-adjust: none;
}

.agreement-confirm-main-box {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
    background: url("https://qiming-1308147483.cos.ap-chengdu.myqcloud.com/doc%2Fpinzhi_shenghuo_huiyuan_quanyi%2Fcommon%2Flogin-shadow-bg.png") repeat;
    z-index: 9993;
}

.agreement-confirm-box {
    border-radius: 10px;
    -webkit-border-radius: 10px;
    background-color: #faf7f2;
    padding: 15px;
    width: 80%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    padding: 31px 29px 19px;
}

.agreement-confirm-box .title {
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    text-align: center;
}

.agreement-confirm-box .content {
    font-size: 16px;
    color: #000000;
    text-align: justify;
    margin-top: 15px;
    line-height: 1.4;
    width: 100%;
}

/* 兜底：确保无任何间距 */
.agreement-confirm-box .content .content-text {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
    -webkit-word-wrap: break-word;
    -webkit-white-space: normal;
    font-size: 0;
    /* 兜底消除字符空白 */
}

.agreement-confirm-box .content .agree-item {
    display: inline;
    font-size: 14px;
    /* 还原字号 */
    margin: 0 !important;
    padding: -4px !important;
    letter-spacing: 0 !important;
}

.agreement-confirm-box .content .content-desc {
    font-size: 14px;
    /* 还原字号 */
    margin-left: 0px !important;
    /* 彻底无间距，可改1px微调 */
    letter-spacing: 0 !important;
}

.agreement-confirm-box .content .tip {
    color: #f3d698;
    text-decoration: none;
    -webkit-text-decoration: none;
}

.agreement-confirm-box .submit-btn {
    height: 45px;
    background: #3477fc;
    border-radius: 27px;
    -webkit-border-radius: 27px;
    margin-top: 26px;
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
}

.agreement-confirm-box .router-btn-inner {
    height: 55px;
    line-height: 55px;
    background: #3477fc;
    border-radius: 27px;
    -webkit-border-radius: 27px;
    margin-top: 26px;
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
}

.agreement-confirm-box .cancel-btn {
    text-align: center;
    margin-top: 18px;
    font-size: 12px;
    font-weight: 500;
    color: #999999;
}
</style>
